/**
 * @generated SignedSource<<22992e911c08a368a6b30215146c38c1>>
 * @relayHash 544ad72d40227b17bb78df91426dec70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6afc87c0f4c803f5822834c59a9fb77fd6fcdadf8bc242b9934286d8276bad4f

import type { ConcreteRequest } from 'relay-runtime';
export type AsyncPlanActionMenuContentQuery$variables = {
  planAri: string;
};
export type AsyncPlanActionMenuContentQuery$data = {
  readonly jira: {
    readonly planById: {
      readonly hasPlanInvitePermission: boolean | null;
    } | null;
  } | null;
};
export type AsyncPlanActionMenuContentQuery = {
  response: AsyncPlanActionMenuContentQuery$data;
  variables: AsyncPlanActionMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "planAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "hasPlanInvitePermission"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AsyncPlanActionMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraPlan",
            "kind": "LinkedField",
            "name": "planById",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsyncPlanActionMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraPlan",
            "kind": "LinkedField",
            "name": "planById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6afc87c0f4c803f5822834c59a9fb77fd6fcdadf8bc242b9934286d8276bad4f",
    "metadata": {},
    "name": "AsyncPlanActionMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "99b6991c2dc7a7c9859f3c1d055fe43c";

export default node;
